import React from "react";
import './App.css'; // Loads in the CSS styling file
import ChatPage from "./pages/ChatPage"; 
import HomePage from "./pages/HomePage"; 
import { BrowserRouter, Routes, Route,} from "react-router-dom"; // This imports the libraries needed for the user to navigate (i.e. "route") to different pages 


function App() {
  return (
    <div>

      <BrowserRouter>
        <Routes>
        <Route path="/" element={<HomePage />} /> Default routes to homepage when root URL is accessed.
        <Route path="/blog/:id" element={<ChatPage />} />
          {/* <Route path="/" element={<ChatPage />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

